export default __webpack_public_path__ + "static/media/acae_add.3ebbd048.svg";